/**
 * 控制台大屏
 * zxw
 * 2024-05-21
 */
import * as ReactDOM from 'react-dom/client';
import React, { useEffect, useState } from 'react';
import { Row, Col,message } from 'antd';
import { 
    MenuOutlined, 
    SkinOutlined,
    VideoCameraOutlined } from '@ant-design/icons';
import $ from 'jquery';
import { winHeight,UjoinParams,AddRequestHeaders,DeleteCookies } from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

import Time from './Time';
import IDHMC from './IDHMC';
import IDSTC from './IDSTC';
import IDINC from './IDINC';
import IDREC from './IDREC';
import ITYEC from './ITYEC';
import IDOPC from './IDOPC';

// import GDMap from './GDMap';
import AMapContainer from './AMapContainer.js';
import FloatVideoWindow from '../../components/videos/FloatVideoWindow';

const DBanner = (props) => {
    return <div style={{ height: '20px', width: '100%', backgroundColor: props.tbgColor }}>
        <Row>
            <Col span={6}>
                <div style={{
                    width: '100%',
                    height: 20,
                    borderTop: '1px solid #04C0C2',
                    borderBottom: '1px solid #04C0C2',
                    position: 'relative'
                }}>
                    <div style={{
                        width: 60,
                        height: 16,
                        borderBottom: '4px solid #04C0C2',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                    }}></div>
                    <div style={{
                        width: 4,
                        height: 4,
                        background: 'linear-gradient(45deg, #04C0C2 50%, ' + props.tbgColor + ' 50%)',
                        position: 'absolute',
                        top: 16,
                        left: 60,
                    }}></div>
                    <div style={{
                        zIndex: 10,
                        position: 'absolute',
                        width: 2,
                        height: 21,
                        transform: 'skew(20deg)',
                        background: '#04C0C2',
                        right: 0,
                        top: 0,
                    }}></div>
                    <div style={{
                        zIndex: 10,
                        position: 'absolute',
                        width: 2,
                        height: 21,
                        transform: 'skew(20deg)',
                        background: '#04C0C2',
                        right: 4,
                        top: 0,
                    }}></div>
                </div>
            </Col>
            <Col span={12}>
                <div style={{
                    width: '100%',
                    height: 21,
                    borderBottom: '1px solid #04C0C2',
                    background: props.tbgColor,
                    position: 'relative',
                    textAlign: 'center',
                    color: '#fff',
                }}>
                    <Time />
                    <div style={{
                        position: 'absolute',
                        width: 2,
                        height: 21,
                        transform: 'skew(20deg)',
                        background: '#04C0C2',
                        left: 2,
                        top: 0,
                    }}></div>
                    <div style={{
                        position: 'absolute',
                        width: 2,
                        height: 21,
                        transform: 'skew(-20deg)',
                        backgroundColor: '#04C0C2',
                        right: 2,
                        top: 0,
                    }}></div>

                </div>
            </Col>
            <Col span={6}>
                <div style={{
                    width: '100%',
                    height: 20,
                    borderTop: '1px solid #04C0C2',
                    borderBottom: '1px solid #04C0C2',
                    position: 'relative'
                }}>
                    <div style={{
                        width: 60,
                        height: 16,
                        borderBottom: '4px solid #04C0C2',
                        position: 'absolute',
                        top: 0,
                        right: 0,
                    }}></div>
                    <div style={{
                        zIndex: 10,
                        position: 'absolute',
                        width: 2,
                        height: 21,
                        transform: 'skew(-20deg)',
                        background: '#04C0C2',
                        left: 0,
                        top: 0,
                    }}></div>
                    <div style={{
                        zIndex: 10,
                        position: 'absolute',
                        width: 2,
                        height: 21,
                        transform: 'skew(-20deg)',
                        background: '#04C0C2',
                        left: 4,
                        top: 0,
                    }}></div>
                    <div style={{
                        width: 4,
                        height: 4,
                        background: 'linear-gradient(-45deg, #04C0C2 50%, ' + props.tbgColor + ' 50%)',
                        position: 'absolute',
                        top: 16,
                        right: 60,
                    }}></div>
                </div>
            </Col>
        </Row>
    </div>
}

const Dashboard = () => {
    const [IDINCdata, setIDINCData] = useState([]);
    //  是否展示视频窗口
    const [isShowVideo, setIsShowVideo] = useState(0);
    //  主题皮肤
    const [theme, setTheme] = useState(CNF.themes[0].number);
    //  大屏名称
    const [dashboardName, setDashboardName] = useState('');
    //  默认主题
    const [lineColor, setLineColor] = useState(CNF.themes[0].lineColor);     //  线条颜色
    const [tbgColor,setTbgColor] = useState(CNF.themes[0].tbgColor);         //  标题背景
    const [cbgColor,setCbgColor] = useState(CNF.themes[0].cbgColor);         //  内容背景

    //  切换皮肤
    const changeTheme = (theme) => {
        setLineColor(CNF.themes[theme - 1].lineColor);
        setTbgColor(CNF.themes[theme - 1].tbgColor);
        setCbgColor(CNF.themes[theme - 1].cbgColor);
    }

    useEffect(() => {
        changeTheme(theme);
    }, [theme]);

    useEffect(() => {
        const params = {
            'page_size': 1,
            'current_index': 1
        };
        $.ajax({
            url: `${CNF.api}setting/areas${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    if(data.dat.length > 0){
                        changeTheme(parseInt(data.dat[0].theme_number));
                        setDashboardName(data.dat[0].dashboard_name);
                    }
                }else{
                    message.error(data.msg, 1.5);
                    setTimeout(() => {
                        //  删除cookie转至登录界面
                        DeleteCookies();
                    }, 1500);
                }
            }
        })
    }, []);

    return <>
        <div>
            <div style={{ width: '100%', position: 'relative' }}>
                <div style={{
                    width: '100%',
                    display: 'flex',
                    height: 35,
                    backgroundColor: tbgColor,
                    color: '#fff',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <h3>{dashboardName?dashboardName:'交通设备综合信息管理大屏'}</h3>
                </div>
                <div style={{
                    position: 'absolute',
                    zIndex: 99,
                    top: 0,
                    right: 0,
                    width: 55,
                    height: 35,
                    display: 'flex',
                    alignItems: 'center',
                    color: '#fff',
                    fontSize: 12,
                }}><span style={{ marginRight: 5 }}><VideoCameraOutlined onClick={() => {
                    setIsShowVideo(isShowVideo?0:1);
                }} /></span><span style={{ marginRight: 5 }}><SkinOutlined onClick={() => {
                    if(theme === 1){
                        setTheme(2);
                    }else{
                        setTheme(1);
                    }
                }} /></span><span style={{ marginRight: 5 }}><MenuOutlined onClick={() => {
                    window.location.href = '/intersections';
                }} /></span></div>
            </div>
            <DBanner tbgColor={tbgColor} />
            <div style={{ 
                height: winHeight - 85, 
                padding: '20px 10px 10px 10px', 
                background: cbgColor, 
                border: 'solid 0px red' }}>
                <Row>
                    <Col span={6} style={{
                        paddingRight: 5,
                    }}>
                        <div style={{ position: 'relative' }}>
                            <div style={{
                                border: '1px solid',
                                borderColor: lineColor,
                                height: (winHeight - 113) / 3
                            }}><IDHMC lineColor={lineColor} /></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                borderTop: '2px solid #04C0C2',
                                borderLeft: '2px solid #04C0C2',
                            }}></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                borderTop: '2px solid #04C0C2',
                                borderRight: '2px solid #04C0C2',
                            }}></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                borderBottom: '2px solid #04C0C2',
                                borderLeft: '2px solid #04C0C2',
                            }}></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                bottom: 0,
                                right: 0,
                                borderBottom: '2px solid #04C0C2',
                                borderRight: '2px solid #04C0C2',
                            }}></div>
                        </div>
                        <div style={{ position: 'relative', marginTop: 10 }}>
                            <div style={{
                                border: '1px solid',
                                borderColor: lineColor,
                                height: (winHeight - 113) / 3
                            }}><IDSTC /></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                borderTop: '2px solid #04C0C2',
                                borderLeft: '2px solid #04C0C2',
                            }}></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                borderTop: '2px solid #04C0C2',
                                borderRight: '2px solid #04C0C2',
                            }}></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                borderBottom: '2px solid #04C0C2',
                                borderLeft: '2px solid #04C0C2',
                            }}></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                bottom: 0,
                                right: 0,
                                borderBottom: '2px solid #04C0C2',
                                borderRight: '2px solid #04C0C2',
                            }}></div>
                        </div>
                        <div style={{ position: 'relative', marginTop: 10, marginBottom: 10 }}>
                            <div style={{
                                border: '1px solid',
                                borderColor: lineColor,
                                height: (winHeight - 113) / 3
                            }}><IDINC setIDINCData={setIDINCData} /></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                borderTop: '2px solid #04C0C2',
                                borderLeft: '2px solid #04C0C2',
                            }}></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                borderTop: '2px solid #04C0C2',
                                borderRight: '2px solid #04C0C2',
                            }}></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                borderBottom: '2px solid #04C0C2',
                                borderLeft: '2px solid #04C0C2',
                            }}></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                bottom: 0,
                                right: 0,
                                borderBottom: '2px solid #04C0C2',
                                borderRight: '2px solid #04C0C2',
                            }}></div>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{
                            margin: '0 5px',
                            border: '1px solid',
                            borderColor: lineColor,
                            borderBottom: 0,
                            position: 'relative',
                            paddingBottom: 5,
                            // background: 'linear-gradient(to bottom,#020D3A,#033448)', 
                            background: 'linear-gradient(to bottom,' + tbgColor +',#033448)', 
                            opacity: 1,
                        }}>
                                <Row style={{ textAlign: 'center',height:'45px',lineHeight:'45px', color: '#FFEC7B' }}>
                                    <Col offset={8} span={4}><div style={{ fontSize: '40px'}}>{IDINCdata.length===2?IDINCdata[0].type==='未联网'?IDINCdata[0].count:IDINCdata[1].count:0}</div></Col>
                                    <Col span={4}><div style={{ fontSize: '40px' }}>{IDINCdata.length===2?IDINCdata[0].type==='已联网'?IDINCdata[0].count:IDINCdata[1].count:0}</div></Col>
                                </Row>
                                <Row style={{ textAlign: 'center',height:'15px',lineHeight:'15px', color: '#fff' }}>
                                    <Col offset={8} span={4}><div style={{ fontSize: '12px'}}>未联网主机数</div></Col>
                                    <Col span={4}><div style={{ fontSize: '12px' }}>已联网主机数</div></Col>
                                </Row>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                top: -1,
                                left: -1,
                                borderTop: '2px solid #04C0C2',
                                borderLeft: '2px solid #04C0C2',
                            }}></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                top: -1,
                                right: -1,
                                borderTop: '2px solid #04C0C2',
                                borderRight: '2px solid #04C0C2',
                            }}></div>
                        </div>
                        <div style={{ 
                            border: '1px solid',
                            borderColor: lineColor, 
                            borderTop:0, 
                            height: winHeight - 154, //154，89
                            margin: '0 5px',
                            position: 'relative',
                        }}>
                            {/* <GDMap /> */}
                            <AMapContainer />
                        </div>
                    </Col>
                    <Col span={6} style={{
                        paddingLeft: 5,
                    }}>
                        <div style={{ position: 'relative' }}>
                            <div style={{
                                border: '1px solid',
                                borderColor: lineColor,
                                height: (winHeight - 113) / 3
                            }}><ITYEC lineColor={lineColor} /></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                borderTop: '2px solid #04C0C2',
                                borderLeft: '2px solid #04C0C2',
                            }}></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                borderTop: '2px solid #04C0C2',
                                borderRight: '2px solid #04C0C2',
                            }}></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                borderBottom: '2px solid #04C0C2',
                                borderLeft: '2px solid #04C0C2',
                            }}></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                bottom: 0,
                                right: 0,
                                borderBottom: '2px solid #04C0C2',
                                borderRight: '2px solid #04C0C2',
                            }}></div>
                        </div>
                        <div style={{ position: 'relative', marginTop: 10 }}>
                            <div style={{
                                border: '1px solid',
                                borderColor: lineColor,
                                height: (winHeight - 113) / 3
                            }}><IDREC /></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                borderTop: '2px solid #04C0C2',
                                borderLeft: '2px solid #04C0C2',
                            }}></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                borderTop: '2px solid #04C0C2',
                                borderRight: '2px solid #04C0C2',
                            }}></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                borderBottom: '2px solid #04C0C2',
                                borderLeft: '2px solid #04C0C2',
                            }}></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                bottom: 0,
                                right: 0,
                                borderBottom: '2px solid #04C0C2',
                                borderRight: '2px solid #04C0C2',
                            }}></div>
                        </div>
                        <div style={{ position: 'relative', marginTop: 10, marginBottom: 10 }}>
                            <div style={{
                                border: '1px solid',
                                borderColor: lineColor,
                                height: (winHeight - 113) / 3
                            }}><IDOPC /></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                borderTop: '2px solid #04C0C2',
                                borderLeft: '2px solid #04C0C2',
                            }}></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                borderTop: '2px solid #04C0C2',
                                borderRight: '2px solid #04C0C2',
                            }}></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                borderBottom: '2px solid #04C0C2',
                                borderLeft: '2px solid #04C0C2',
                            }}></div>
                            <div style={{
                                zIndex: 10,
                                width: 12,
                                height: 12,
                                position: 'absolute',
                                bottom: 0,
                                right: 0,
                                borderBottom: '2px solid #04C0C2',
                                borderRight: '2px solid #04C0C2',
                            }}></div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div >
        <FloatVideoWindow open={isShowVideo} />
    </>
}

export default Dashboard;